import { render, staticRenderFns } from "./QuestionStitcher.vue?vue&type=template&id=36221131&"
import script from "./QuestionStitcher.vue?vue&type=script&lang=js&"
export * from "./QuestionStitcher.vue?vue&type=script&lang=js&"
import style0 from "./QuestionStitcher.vue?vue&type=style&index=0&soped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports